import { render, staticRenderFns } from "./BmProductos.vue?vue&type=template&id=767bf87c&"
import script from "./BmProductos.vue?vue&type=script&lang=js&"
export * from "./BmProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports